@if (isVisible()) {
  <div class="flex my-4 tablet:my-5 desktop:my-6">
    <div
      class="w-2 flex justify-center items-center"
      [ngClass]="{
        'bg-infoBlocks-success-text': type() === StatusMessageType.Success,
        'bg-infoBlocks-info-text': type() === StatusMessageType.Info,
        'bg-infoBlocks-error-text': type() === StatusMessageType.Error
      }"
    ></div>

    <div
      class="p-4 tablet:p-5 desktop:p-6 flex justify-between items-center tablet:gap-x-10 desktop:gap-x-12 w-full"
      [ngClass]="{
        'bg-infoBlocks-success-background': type() === StatusMessageType.Success,
        'bg-infoBlocks-info-background': type() === StatusMessageType.Info,
        'bg-infoBlocks-error-background': type() === StatusMessageType.Error
      }"
    >
      <div>
        <h4
          class="font-sans font-semibold text-sm tablet:text-base leading-normal tracking-normal mb-1.5"
          [ngClass]="{
            'text-infoBlocks-success-text': type() === StatusMessageType.Success,
            'text-infoBlocks-info-text': type() === StatusMessageType.Info,
            'text-infoBlocks-error-text': type() === StatusMessageType.Error
          }"
        >
          {{ widgetTitle | scTranslate | async }}
        </h4>

        <p
          class="text-sm tablet:text-base"
          [innerHTML]="subtitle() | scTranslate | async | scSentenceBreak"
        ></p>
      </div>

      @if (!isCrossBtnHidden()) {
        <sc-button
          variant="icon"
          [padding]="false"
          (click)="closeInfoBlock()"
          title="Close"
        >
          <sc-svg name="close" size="w-5 h-5"></sc-svg>
        </sc-button>
      }
    </div>
  </div>
}